import React from "react";
import { useNavigate, Link } from "react-router-dom";
import '../assets/Home.css';

function CustCategories({items}) {
  const navigate = useNavigate();
  const itemsValues = Object.values(items);
  // eslint-disable-next-line
  let customizations = Object.keys(itemsValues[0].customizations)
  const mapIndex = () => itemsValues.map((item) => 
     customizations = Object.keys(item.customizations) 
  )
  const cust = Object.entries(mapIndex())

  return (
    <div className="compCust" id="categories">
        <div className="compWrapper">
          <h3 className="compTitle">Customization Categories</h3>
          <div className="flexContainer" >
          {itemsValues.map((item, index) => {
            return (
              <div
                key={index}
                className="custWrapper"
                onClick={() => {
                  navigate(`/customization/${item.slug}/${cust[index][1][0]}`);
                }}
              >
                <div key={index} className="custContainer">
                    <img key={index} src={`${item.icon}`} title={item.title} alt={item.title} loading="lazy"/>
                </div>
                <Link key={index} to={`/customization/${index}#${item.slug}/0`}  className="CustCategName"> {item.title}</Link>
              </div>
            );
          })}
          </div>
        </div>
    </div>
  );
}
export default CustCategories;